/* FAQ: acordeon (la regla de la fila se rellena a 540px/s al abrir), riel
   pegajoso solo mientras comparte fila con la columna, seccion activa. */
const { mount, reveal, registrar, reduced, SPEED } = window.EQ;

mount('[data-eq-faq]', (root) => {
  const rev = reveal(root);
  const unreg = registrar(root);
  const unaSola = root.dataset.una === 'true';
  const lento = reduced();

  // ---- entrada de las filas: registro de Contacto ---------------------------
  // SIN IntersectionObserver: la fila nace recortada al 100% y el observer le
  // aplica ese recorte al propio target, asi que su area visible es cero y nunca
  // "entra". Se mide con getBoundingClientRect (ignora el clip-path) en cada
  // scroll, un rAF por cuadro. Escalonado de 70ms hasta la septima fila del
  // lote. Marca de "ya abierta" en un WeakSet.
  const filas = Array.from(root.querySelectorAll('[data-eq-fila]'));
  const abiertas = new WeakSet();
  let rafF = 0, tRes = 0;
  const abrirFila = (el, d) => {
    if (abiertas.has(el)) return;
    abiertas.add(el);
    el.style.transitionDelay = d + 'ms';
    el.classList.add('is-in');
  };
  const scanFilas = () => {
    rafF = 0;
    const h = window.innerHeight || 800;
    let i = 0;
    filas.forEach((el) => {
      if (abiertas.has(el)) return;
      const r = el.getBoundingClientRect();
      if (r.top < h * 0.94 && r.bottom > 0) { abrirFila(el, Math.min(i, 6) * 70); i++; }
    });
  };
  const pedirScan = () => { if (!rafF) rafF = requestAnimationFrame(scanFilas); };
  if (lento) filas.forEach((el) => abrirFila(el, 0));
  else {
    pedirScan();
    // rescate: despues de fuentes y layout, por si el primer cuadro midio antes
    tRes = setTimeout(pedirScan, 900);
  }

  const onClick = (e) => {
    const q = e.target.closest('[data-eq-q]');
    if (q) {
      const item = q.closest('.eq-faq__item');
      const abierta = item.classList.contains('is-open');
      const regla = item.querySelector('[data-eq-regla]');
      if (regla) { const w = regla.getBoundingClientRect().width || 480; regla.style.transition = 'clip-path ' + Math.round(w / (SPEED / 1000)) + 'ms linear'; }
      if (unaSola) root.querySelectorAll('.eq-faq__item.is-open').forEach((it) => { it.classList.remove('is-open'); it.querySelector('[data-eq-q]').setAttribute('aria-expanded', 'false'); });
      item.classList.toggle('is-open', !abierta);
      q.setAttribute('aria-expanded', abierta ? 'false' : 'true');
      return;
    }
    const ir = e.target.closest('[data-eq-ir]');
    if (ir) {
      const el = root.querySelector('[data-eq-sec="' + ir.dataset.eqIr + '"]');
      if (!el) return;
      const y = window.scrollY + el.getBoundingClientRect().top - 140;
      window.scrollTo({ top: y, behavior: lento ? 'auto' : 'smooth' });
    }
  };

  // el riel solo puede ser pegajoso MIENTRAS comparte fila con la columna:
  // al envolverse el flex, el sticky se desliza encima del texto. Se mide.
  const pegarRiel = () => {
    const riel = root.querySelector('[data-eq-riel]'), main = root.querySelector('[data-eq-main]');
    if (!riel || !main) return;
    riel.classList.add('is-static');
    const juntos = Math.abs(riel.offsetTop - main.offsetTop) < 4;
    riel.classList.toggle('is-static', !juntos);
  };
  const marcarSeccion = () => {
    let act = null;
    root.querySelectorAll('[data-eq-sec]').forEach((s) => { if (s.getBoundingClientRect().top < 220) act = s.dataset.eqSec; });
    if (!act) { const f = root.querySelector('[data-eq-sec]'); act = f && f.dataset.eqSec; }
    root.querySelectorAll('[data-eq-ir]').forEach((b) => b.classList.toggle('is-on', b.dataset.eqIr === act));
  };
  const onScroll = () => { marcarSeccion(); if (!lento) pedirScan(); };
  const onResize = () => { marcarSeccion(); pegarRiel(); if (!lento) pedirScan(); };

  root.addEventListener('click', onClick);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  pegarRiel(); marcarSeccion();

  return () => {
    rev.destroy(); unreg();
    if (rafF) cancelAnimationFrame(rafF);
    clearTimeout(tRes);
    root.removeEventListener('click', onClick);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onResize);
  };
});
